module.exports = "//static.hsappstatic.net/conversations-visitor-message-history/static-1.21579/img/ai-avatar.png"